export const SESSION_STORAGE_KEYS = {
  WIDGET_OPEN_ON_LOAD: 'wgptWidgetOpenOnLoad',
};
